import { useState } from 'react'
import { deleteSmartMeterContract, modifySmartMeterContract, readSmartMeterContract, uploadSmartMeterContract } from '../api/shop-smart-meter.api'
import { ShopCheckoutSideBarResponse } from '../models'
import { useShopFetchWithResult } from './use-shop-fetch'
import { SmartMeterFormValues } from '../components/SystemConfiguration/SmartMeter/SmartMeterForm'

/*
 * This Custom Hook have all Smart Meter Endpoints.
 */

interface UseShopSmartMeterHook {
  addSmartMeterContract: (productId: string, pdf: Blob, contractData: SmartMeterFormValues) => Promise<ShopCheckoutSideBarResponse | null>
  removeSmartMeterContract: (productId: string, documentId: string) => Promise<ShopCheckoutSideBarResponse | null>
  openSmartMeterContract: (productId: string, documentId: string) => Promise<string | null>
  editSmartMeterContract: (
    productId: string,
    documentId: string,
    pdf: Blob | null,
    contractData: SmartMeterFormValues
  ) => Promise<ShopCheckoutSideBarResponse | null>
  isLoading: boolean
}

const useShopSmartMeter = (): UseShopSmartMeterHook => {
  const shopFetch = useShopFetchWithResult()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const addSmartMeterContract = async (
    productId: string,
    pdf: Blob,
    contractData: SmartMeterFormValues
  ): Promise<ShopCheckoutSideBarResponse | null> => {
    try {
      setIsLoading(true)
      const response = await uploadSmartMeterContract(productId, pdf, contractData, shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const removeSmartMeterContract = async (productId: string, documentId: string): Promise<ShopCheckoutSideBarResponse | null> => {
    try {
      setIsLoading(true)
      const response = await deleteSmartMeterContract(productId, documentId, shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const openSmartMeterContract = async (productId: string, documentId: string): Promise<string | null> => {
    try {
      setIsLoading(true)
      const response = await readSmartMeterContract(productId, documentId, shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const editSmartMeterContract = async (
    productId: string,
    documentId: string,
    pdf: Blob | null,
    contractData: SmartMeterFormValues
  ): Promise<ShopCheckoutSideBarResponse | null> => {
    try {
      setIsLoading(true)
      const response = await modifySmartMeterContract(productId, documentId, pdf, contractData, shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  return {
    addSmartMeterContract,
    removeSmartMeterContract,
    openSmartMeterContract,
    editSmartMeterContract,
    isLoading,
  }
}

export default useShopSmartMeter
